<template>
  <div style="width:100%;height:100%">
    <div ref="chart" style="width:100%;height:100%"></div>
  </div>
</template>

<script>
import 'echarts-liquidfill/src/liquidFill.js'; //在这里引入
export default {
  props:{
    chartData:{
      type:Array,
      default:()=>[]
    }
  },  
  data() {
    return {

    }
  },
  // mounted() {
  //   this.getEchartData()
  // },
  methods: {
    getEchartData(data) {
      // let data = [
      //   { value: 201,ratio:'37.22%', name: '矛...' },
      //   { value: 268,ratio:'49.63%', name: '城...' },
      //   { value: 71,ratio:'13.15%', name: '社会...' },
      // ]
      // let data = this.chartData;
      const chart = this.$refs.chart
      if (chart) {
        const myChart = this.$echarts.init(chart)
        const option = {
          tooltip: {
            trigger: 'item'
          },
          color:['#DAC741','#298FF2','#5565FF','#29E4E8','#26EF5D','#DF7438'],
          legend: {
            orient: "horizontal",
            top: "25%",
            // right: "left",
            left:"26%",
            itemGap: 10,
            selectedMode: true,
            icon: "pin",
            textStyle: {
              color: "#D5E7E7",
              rich: {
                name: {
                  width: 70,
                },
                num: {
                  width: 40,
                  align: "center",
                },
                ratio: {
                  width: 40,
                  // align: "right",
                },
              },
            },
            formatter(name) {
              var maxLength = 5; // 设置最大长度
              for (let index = 0; index < data.length; index++) {
                const item = data[index];
                if(name == item.name){
                  let newName = '';
                  if (item.name.length > maxLength) {
                    newName = item.name.substring(0, maxLength) + '...'; // 截取前面部分并添加省略号
                  } else {
                    newName = item.name;
                  }
                  return `{name|${newName}}{num|${item.num}}{ratio|${item.ratio}%}`;
                }
              }
            },
          },
          series: [
            {
              type: 'pie',
              radius: ['45%', '70%'],
              center:["15%",'50%'],
              avoidLabelOverlap: false,
              label: {
                show: false,
                position: 'center'
              },
              data,
            }
          ]
        };
        myChart.setOption(option)
        window.addEventListener("resize", function () {
          myChart.resize()
        })
      }
      this.$on('hook:destroyed', () => {
        window.removeEventListener("resize", function () {
          myChart.resize();
        });
      })
    },
  },
}
</script>